import CustomTooltip from 'components/Tooltip';
import HelpIcon from 'assets/icons/help-black.svg';

const TextFieldLabel = ({
  label,
  tooltip,
  name,
  labelStyle
}: {
  label: string | undefined;
  tooltip: string | undefined;
  name: string;
  labelStyle?: string;
}) => {
  return (
    <div className='flex flex-row items-center justify-start gap-1'>
      {label && <p className={`text-base font-light ${labelStyle}`}>{label}</p>}
      {!!tooltip && (
        <CustomTooltip
          id={name}
          content={tooltip}
          icon={HelpIcon}
          className='w-4 h-4'
        />
      )}
    </div>
  );
};

export default TextFieldLabel;
